<div class="container">
  <h1 class="page-title"><span class="icon"><i class="fas fa-truck-moving"></i></span>{{ 'ReceiptFormHeaderDetailsEdit.ReceiptEdit' | translate }}</h1>
  <p-card>
    <form class="detail-form" [formGroup]="editForm">
      <div class="field grid">
        <div class="p-fluid formgrid grid">
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ReceiptNum' | translate }}</label>
            <div class="col-8 column-value">
              {{ warehousingHeader?.whNo | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ImportDeclarationNum' | translate }}</label>
            <div class="col-8 column-value">
              {{ warehousingHeader?.importDeclarationNo | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ReceiptStatus' | translate }}</label>
            <div class="col-8 column-value">
              {{ warehousingHeader?.whStatus | optionsMapping:whDocStatusOptions | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.Forwarder' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="shipper" [filter]="true" [options]="forwarderOptions" [(ngModel)]="warehousingHeader.shipper" [disabled]="!isShipperEdit"
                [class]="showValidationMessage(editForm.controls.shipper , submitted) ? ['ng-invalid', 'ng-dirty'] : []"
                 ></p-dropdown>
              <small
                *ngIf="((submitted || editForm.controls.shipper.touched) && editForm.controls.shipper.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.PayeeType' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="billObjectType" [filter]="true" (onChange)="changeBillObject()" [options]="billObjectTypeOptions" [(ngModel)]="warehousingHeader.billObjectType"
              [class]="showValidationMessage(editForm.controls.billObjectType , submitted) ? ['ng-invalid', 'ng-dirty'] : []"
              ></p-dropdown>
              <small
                *ngIf="((submitted || editForm.controls.billObjectType.touched) && editForm.controls.billObjectType.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.Payee' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="billObject" [filter]="true" [options]="billObjectOptions" [(ngModel)]="warehousingHeader.billObject"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
              <small
                *ngIf="((submitted || editForm.controls.billObject.touched) && editForm.controls.billObject.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span *ngIf="updateValidity(editForm.controls.vendorCustomer)" class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.Supplier' | translate }}</label>
            <div class="col-8 column-value">
              <p-autoComplete formControlName="vendorCustomer" [(ngModel)]="warehousingHeader.vendorCustomer" [suggestions]="vendorSuggests" (completeMethod)="getVendorOptions($event)"></p-autoComplete>
              <small
                *ngIf="((submitted || editForm.controls.vendorCustomer.touched) && editForm.controls.vendorCustomer.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.DeliveryType' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="deliveryType" [filter]="true" [options]="deliveryTypeOptions" [(ngModel)]="warehousingHeader.deliveryType"
              [disabled]="idEditDeliveryType"  ></p-dropdown>
              <small
                *ngIf="((submitted || editForm.controls.deliveryType.touched) && editForm.controls.deliveryType.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <ng-container [ngSwitch]="warehousingHeader.whStatus">
              <ng-container *ngSwitchCase="'0'">
                <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.Company' | translate }}</label>
                <div class="col-8 column-value">
                  <p-dropdown formControlName="orgId" [filter]="true" [options]="orgIdOptions" (onClick)="changeBillCorpOptions()" [(ngModel)]="warehousingHeader.orgId"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
              <small
                *ngIf="((submitted || editForm.controls.orgId.touched) && editForm.controls.orgId.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
              </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.Company' | translate }}</label>
                <div class="col-8 column-value">
                  {{ warehousingHeader?.orgId | optionsMapping:orgIdMappingOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.BillCompany' | translate }}</label>
            <div class="col-8 column-value">
              {{ warehousingHeader?.billCorp | optionsMapping:orgIdMappingOptions | replaceNullWith:'-' }}
            </div>
          </div>
          <!-- 起運地位置選擇 -->
            <laas-location-cascade-dropdown
              formControlName="fromLocation"
              [showCountry]="true"
              [showCity]="true"
              [showArea]="true"
              [showExpressArea]="false"
              [showDistrict]="false"
              [useMultiSelectForCountry]="false"
              [useMultiSelectForCity]="false"
              [useMultiSelectForArea]="false"
              [useMultiSelectForExpressArea]="false"
              [useMultiSelectForDistrict]="false"
              countryLabel="{{ 'ReceiptFormHeaderDetails.OriginCountry' | translate }}"
              cityLabel="{{ 'ReceiptFormHeaderDetails.OriginCity' | translate }}"
              areaLabel="{{ 'ReceiptFormHeaderDetails.OriginArea' | translate }}"
              countryPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
              cityPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
              areaPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [allowAllOption]="false"
              [showClear]="false"
              [enableFilter]="true"
              [cssClasses]="'field grid col-6 align-items-baseline'"
              [labelClasses]="'col-4 column-label'"
              [valueClasses]="'col-8 column-value'"
              [submitted]="submitted"
              [showValidation]="true"
              [requiredFields]="['country', 'city']"
              (countryOptionsReady)="onCountryOptionsReady($event)"
              (cityOptionsReady)="onCityOptionsReady($event)"
              (areaOptionsReady)="onAreaOptionsReady($event)">
            </laas-location-cascade-dropdown>


          <!-- 目的地位置選擇 -->
            <laas-location-cascade-dropdown
              formControlName="toLocation"
              [showCountry]="true"
              [showCity]="true"
              [showArea]="true"
              [showExpressArea]="false"
              [showDistrict]="false"
              [useMultiSelectForCountry]="false"
              [useMultiSelectForCity]="false"
              [useMultiSelectForArea]="false"
              [useMultiSelectForExpressArea]="false"
              [useMultiSelectForDistrict]="false"
              countryLabel="{{ 'ReceiptFormHeaderDetails.DestinationCountry' | translate }}"
              cityLabel="{{ 'ReceiptFormHeaderDetails.DestinationCity' | translate }}"
              areaLabel="{{ 'ReceiptFormHeaderDetails.DestinationArea' | translate }}"
              countryPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
              cityPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
              areaPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [allowAllOption]="false"
              [showClear]="true"
              [enableFilter]="true"
              [cssClasses]="'field grid col-6 align-items-baseline'"
              [labelClasses]="'col-4 column-label'"
              [valueClasses]="'col-8 column-value'"
              [submitted]="submitted"
              [showValidation]="true"
             >
            </laas-location-cascade-dropdown>


          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.CourierDeliveryCondition' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="expressTerm" [filter]="true" [showClear]="true" [disabled]="!isExpressTermEdit" [options]="expressTermOptions" [(ngModel)]="warehousingHeader.expressTerm"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DeclarationType' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="docType" [filter]="true" [showClear]="true" [options]="docTypeOptions" [(ngModel)]="warehousingHeader.docType"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.TradeTerm' | translate }}</label>
            <div *ngIf="isShipTermEdit" class="col-8 column-value">
              <p-dropdown formControlName="shipTerm" [filter]="true" [showClear]="true" [options]="shipTermOptions" [(ngModel)]="warehousingHeader.shipTerm" [disabled]="!isShipTermEdit"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
              <small
                  *ngIf="((submitted || editForm.controls.shipTerm.touched) && editForm.controls.shipTerm.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
            <div *ngIf="!isShipTermEdit" class="col-7 column-value">
              {{ warehousingHeader.shipTerm | optionsMapping:shipTermOptions | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ReceivingTime' | translate }}</label>
            <div class="col-8 column-value">
              <p-calendar formControlName="whDtTimeZone"  [showTime]="true" dateFormat="yy/mm/dd"  hourFormat="24"
                  [monthNavigator]="true" [yearNavigator]="true" [(ngModel)]="warehousingHeader.whDtTimeZone"  ></p-calendar>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.EstimateArrivalDate' | translate }}</label>
            <div class="col-8 column-value">
              <p-calendar formControlName="expectedDtTimeZone" dataType="string" dateFormat="yy/mm/dd"
                  [monthNavigator]="true" [yearNavigator]="true" [(ngModel)]="warehousingHeader.expectedDtTimeZone"></p-calendar>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span *ngIf="updateValidity(editForm.controls.hawbNo)" class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.HAWB' | translate }}</label>
            <div class="col-8 column-value">
              <input type="text" pInputText formControlName="hawbNo" [(ngModel)]="warehousingHeader.hawbNo"
              [class]="showValidationMessage(editForm.controls.hawbNo , submitted) ? ['ng-invalid', 'ng-dirty'] : []"   />
              <small
                *ngIf="((submitted || editForm.controls.hawbNo.touched) && editForm.controls.hawbNo.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.NumPallets' | translate }}</label>
            <div class="col-8 column-value">
              <p-inputNumber formControlName="palletCnt" [(ngModel)]="warehousingHeader.palletCnt"
              [class]="showValidationMessage(editForm.controls.palletCnt , submitted) ? ['ng-invalid', 'ng-dirty'] : []"  ></p-inputNumber>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span *ngIf="updateValidity(editForm.controls.totalCartonCnt)" class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.TotalCartonCnt' | translate }}</label>
            <div class="col-8 column-value">
              <p-inputNumber formControlName="totalCartonCnt" [(ngModel)]="warehousingHeader.totalCartonCnt"
              [class]="showValidationMessage(editForm.controls.totalCartonCnt , submitted) ? ['ng-invalid', 'ng-dirty'] : []" ></p-inputNumber>
              <small
                *ngIf="((submitted || editForm.controls.totalCartonCnt.touched) && editForm.controls.totalCartonCnt.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span *ngIf="updateValidity(editForm.controls.totalChargeableWeight)" class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.TotalChargeableWeight' | translate }}</label>
            <div class="col-8 column-value">
              <p-inputNumber formControlName="totalChargeableWeight" [(ngModel)]="warehousingHeader.totalChargeableWeight" mode="decimal" [minFractionDigits]="2"></p-inputNumber>
              <small
                *ngIf="((submitted || editForm.controls.totalChargeableWeight.touched) && editForm.controls.totalChargeableWeight.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.TotalGrossWeight' | translate }}</label>
            <div class="col-8 column-value">
              <p-inputNumber formControlName="totalGrossWeight" [(ngModel)]="warehousingHeader.totalGrossWeight" mode="decimal" [minFractionDigits]="2"></p-inputNumber>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.TotalVolumeWeight' | translate }}</label>
            <div class="col-8 column-value">
              <p-inputNumber formControlName="totalVolumeWeight" [(ngModel)]="warehousingHeader.totalVolumeWeight" mode="decimal" [minFractionDigits]="2"></p-inputNumber>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.NumCartonsReceived' | translate }}</label>
            <div class="col-8 column-value">
              <p-inputNumber formControlName="rfCaseCnt" [(ngModel)]="warehousingHeader.rfCaseCnt"></p-inputNumber>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.TotalQty' | translate }}</label>
            <div class="col-8 column-value">
              <p-inputNumber formControlName="totalQty" [(ngModel)]="warehousingHeader.totalQty"></p-inputNumber>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ActualQty' | translate }}</label>
            <div class="col-8 column-value">
              <p-inputNumber formControlName="cartonCnt" [(ngModel)]="warehousingHeader.cartonCnt"></p-inputNumber>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.CalculationUnit' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="uom" [filter]="true" [showClear]="true" [options]="uomOptions" [(ngModel)]="warehousingHeader.uom"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.CalculateQty' | translate }}</label>
            <div class="col-8 column-value">
              <p-inputNumber formControlName="uomQty" [(ngModel)]="warehousingHeader.uomQty"></p-inputNumber>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.CustomBondedNum' | translate }}</label>
            <div class="col-8 column-value">
              <input type="text" pInputText formControlName="bondedNo" [(ngModel)]="warehousingHeader.bondedNo" />
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.LooseCargoNum' | translate }}</label>
            <div class="col-8 column-value">
              <input type="text" pInputText formControlName="bulkCargoNo" [(ngModel)]="warehousingHeader.bulkCargoNo" />
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.LooseCargoNumLocation' | translate }}</label>
            <div class="col-8 column-value">
              <input type="text" pInputText formControlName="bulkCargoNoLocation" [(ngModel)]="warehousingHeader.bulkCargoNoLocation" />
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.Brand' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="brand" [filter]="true" [showClear]="true" [options]="brandOptions" [(ngModel)]="warehousingHeader.brand"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ReasonNonReceiving' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="shippingRemark" [filter]="true" [showClear]="true" [options]="shippingRemarkOptions" [(ngModel)]="warehousingHeader.shippingRemark"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.DropShipment' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="isDropShipment" [options]="yesNoOptions" [(ngModel)]="warehousingHeader.isDropShipment"
                  ></p-dropdown>
              <small
                *ngIf="((submitted || editForm.controls.isDropShipment.touched) && editForm.controls.isDropShipment.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.GenerateExpenses' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="isGenerateFee" [options]="yesNoOptions" [(ngModel)]="warehousingHeader.isGenerateFee"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
              <small
                *ngIf="((submitted || editForm.controls.isGenerateFee.touched) && editForm.controls.isGenerateFee.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.WarehouseAddress' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="addressCode" [options]="addressCodeOptions" [(ngModel)]="warehousingHeader.addressCode"
                 placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                 [class]="showValidationMessage(editForm.controls.addressCode , submitted) ? ['ng-invalid', 'ng-dirty'] : []" ></p-dropdown>
              <small
                *ngIf="((submitted || editForm.controls.addressCode.touched) && editForm.controls.addressCode.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.PickUpAddress' | translate }}</label>
            <div class="col-8 column-value">
              <input type="text" pInputText formControlName="deliveryAddress" [(ngModel)]="warehousingHeader.deliveryAddress" />
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.IsUrgent' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="urgentFlag" [options]="urgentFlagOptions" [(ngModel)]="warehousingHeader.urgentFlag"
              [class]="showValidationMessage(editForm.controls.urgentFlag , submitted) ? ['ng-invalid', 'ng-dirty'] : []"  ></p-dropdown>
              <small
                *ngIf="((submitted || editForm.controls.urgentFlag.touched) && editForm.controls.urgentFlag.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
              </small>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.FlightNum' | translate }}</label>
            <div class="col-8 column-value">
              <input type="text" pInputText formControlName="flightNo" [(ngModel)]="warehousingHeader.flightNo" />
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.FlightDate' | translate }}</label>
            <div class="col-8 column-value">
              <p-calendar formControlName="flightDtTimeZone" dataType="string" dateFormat="yy/mm/dd"
                  [monthNavigator]="true" [yearNavigator]="true" [(ngModel)]="warehousingHeader.flightDtTimeZone"></p-calendar>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DeliveryMode' | translate }}</label>
            <div class="col-8 column-value">
              <p-dropdown formControlName="shippingMethod" [options]="shippingMethodOptions" [(ngModel)]="warehousingHeader.shippingMethod"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.MAWB' | translate }}</label>
            <div class="col-8 column-value">
              <input type="text" pInputText formControlName="mawbNo" [(ngModel)]="warehousingHeader.mawbNo" />
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.IdentificaitonNum' | translate }}</label>
            <div class="col-8 column-value">
              <input type="text" style="width:15%;" pInputText formControlName="docNo1" maxlength="2" [(ngModel)]="warehousingHeader.docNo1" />/
              <input type="text" style="width:15%;" pInputText formControlName="docNo2" maxlength="2" [(ngModel)]="warehousingHeader.docNo2" />/
              <input type="text" style="width:15%;" pInputText formControlName="docNo3" maxlength="2" [(ngModel)]="warehousingHeader.docNo3" />/
              <input type="text" style="width:15%;" pInputText formControlName="docNo4" maxlength="4" [(ngModel)]="warehousingHeader.docNo4" />/
              <input type="text" style="width:15%;" pInputText formControlName="docNo5" maxlength="5" [(ngModel)]="warehousingHeader.docNo5" />
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <ng-container [ngSwitch]="warehousingHeader.whStatus">
              <ng-container *ngSwitchCase="'0'">
                <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.DocumentSubType' | translate }}</label>
                <div class="col-8 column-value">
                  <p-dropdown formControlName="deliverySubType" [filter]="true" [options]="deliverySubTypeOptions" [(ngModel)]="warehousingHeader.deliverySubType"
                  [class]="showValidationMessage(editForm.controls.deliverySubType , submitted) ? ['ng-invalid', 'ng-dirty'] : []"
                  ></p-dropdown>
                  <small
                    *ngIf="((submitted || editForm.controls.deliverySubType.touched) && editForm.controls.deliverySubType.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                  </small>
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DocumentSubType' | translate }}</label>
                <div class="col-8 column-value">
                  {{ warehousingHeader?.deliverySubType | optionsMapping:deliverySubTypeOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DONum' | translate }}</label>
            <div class="col-8 column-value">
              <input type="text" pInputText formControlName="doNo" [(ngModel)]="warehousingHeader.doNo" />
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ExpensesDistribution' | translate }}</label>
            <div class="col-8 column-value">
              <input type="text" pInputText formControlName="splitDept" [(ngModel)]="warehousingHeader.splitDept" />
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.Creator' | translate }}</label>
            <div class="col-8 column-value">
              {{ warehousingHeader?.createUser | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.CreationTime' | translate }}</label>
            <div class="col-8 column-value">
              {{ warehousingHeader?.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.UpdateBy' | translate }}</label>
            <div class="col-8 column-value">
              {{ warehousingHeader?.updateUser | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.EditTime' | translate }}</label>
            <div class="col-8 column-value">
              {{ warehousingHeader?.updateDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.RFQSetting' | translate }}</label>
            <div class="col-8 column-value">
              <input type="text" pInputText formControlName="quotationKey" [(ngModel)]="warehousingHeader.quotationKey" [attr.disabled]="true" />
            </div>
          </div>

          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.EmployCode' | translate }}</label>
            <div class="col-8 column-value">
              {{ warehousingHeader?.employCode | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'WarehousingAbnormal.Form.IsAbnormalNotify' | translate }}</label>
            <p-dropdown class="col-8 column-value" formControlName="isAbnormalNotify" [(ngModel)]="warehousingHeader.isAbnormalNotify" optionLabel="label" optionValue="value"
              [options]=" yesNoOptions" styleClass="p-text-left"
              [showClear]="false" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
            </p-dropdown>
          </div>
          <div *ngIf="warehousingHeader?.feiliksNotifyFlag" class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.FeiliksNotifyFlag' | translate }}</label>
            <p-dropdown class="col-8 column-value" formControlName="feiliksNotifyFlag" [(ngModel)]="warehousingHeader.feiliksNotifyFlag" optionLabel="label" optionValue="value"
              [options]=" feiliksNotifyFlagOptions" styleClass="p-text-left"
              [showClear]="false" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
            </p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ConsolidationForwarder' | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown formControlName="consolidationForwarder" [filter]="true" [showClear]="true" [options]="forwarderOptions" [(ngModel)]="warehousingHeader.consolidationForwarder" [disabled]="!isShipperEdit"
              [class]="showValidationMessage(editForm.controls.consolidationForwarder , submitted) ? ['ng-invalid', 'ng-dirty'] : []"
               ></p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.CrossBoundryForwarder' | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown formControlName="crossBoundryForwarder" [filter]="true" [showClear]="true"[options]="forwarderOptions" [(ngModel)]="warehousingHeader.crossBoundryForwarder" [disabled]="!isShipperEdit"
              [class]="showValidationMessage(editForm.controls.crossBoundryForwarder , submitted) ? ['ng-invalid', 'ng-dirty'] : []"
               ></p-dropdown>
          </div>
        </div>

      <!-- 集運起運地位置選擇 -->
        <laas-location-cascade-dropdown
          formControlName="consolidationFromLocation"
          [showCountry]="true"
          [showCity]="true"
          [showArea]="true"
          [showExpressArea]="false"
          [showDistrict]="false"
          [useMultiSelectForCountry]="false"
          [useMultiSelectForCity]="false"
          [useMultiSelectForArea]="false"
          [useMultiSelectForExpressArea]="false"
          [useMultiSelectForDistrict]="false"
          countryLabel="{{ 'ReceiptFormHeaderDetails.ConsolidationFromCountry' | translate }}"
          cityLabel="{{ 'ReceiptFormHeaderDetails.ConsolidationFromCity' | translate }}"
          areaLabel="{{ 'ReceiptFormHeaderDetails.ConsolidationFromArea' | translate }}"
          countryPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          cityPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          areaPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          [allowAllOption]="false"
          [showClear]="false"
          [enableFilter]="true"
          [cssClasses]="'field grid col-6 align-items-baseline'"
          [labelClasses]="'col-4 column-label'"
          [valueClasses]="'col-8 column-value'"
          [submitted]="submitted"
          [showValidation]="true"
          (countryOptionsReady)="onCountryOptionsReady($event)"
          (cityOptionsReady)="onCityOptionsReady($event)"
          (areaOptionsReady)="onAreaOptionsReady($event)">
        </laas-location-cascade-dropdown>

      <!-- 集運目的地位置選擇 -->
        <laas-location-cascade-dropdown
          formControlName="consolidationToLocation"
          [showCountry]="true"
          [showCity]="true"
          [showArea]="true"
          [showExpressArea]="false"
          [showDistrict]="false"
          [useMultiSelectForCountry]="false"
          [useMultiSelectForCity]="false"
          [useMultiSelectForArea]="false"
          [useMultiSelectForExpressArea]="false"
          [useMultiSelectForDistrict]="false"
          countryLabel="{{ 'ReceiptFormHeaderDetails.ConsolidationToCountry' | translate }}"
          cityLabel="{{ 'ReceiptFormHeaderDetails.ConsolidationToCity' | translate }}"
          areaLabel="{{ 'ReceiptFormHeaderDetails.ConsolidationToArea' | translate }}"
          countryPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          cityPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          areaPlaceholder="{{ 'Common.Message.ChooseOption' | translate }}"
          [allowAllOption]="false"
          [showClear]="true"
          [enableFilter]="true"
          [cssClasses]="'field grid col-6 align-items-baseline'"
          [labelClasses]="'col-4 column-label'"
          [valueClasses]="'col-8 column-value'"
          [submitted]="submitted"
          [showValidation]="true"
         >
        </laas-location-cascade-dropdown>

        <div class="grid">
          <div class="col">
            <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtnClick($event)" class="mr-2"></button>
            <button pButton pRipple label="{{ 'Common.Button.ReturnWithoutSaving' | translate }}" (click)="goToLastPage()" class="mr-2"></button>
          </div>
        </div>
      </div>
    </form>
  </p-card>
</div>


